/* eslint-disable @typescript-eslint/naming-convention */

import {IFaqItem} from 'modules/events/types';

export const CALENDAR_SLIDE_NEXT_PREV_COUNT = 7;

// eslint-disable-next-line no-shadow
export enum EventFiltersValuesJoinType {
    OR = 'or',
    SINGLE_VALUE = 'SINGLE_VALUE',
}

// eslint-disable-next-line no-shadow
export enum EventFilterCodes {
    date = 'date',
    drinkType = 'drinkType',
    winery = 'winery',
    format = 'format',
    price = 'price',
    hall = 'hall',
}

export const EVENTS_FILTERS_CONFIG = [
    {
        code: EventFilterCodes.date,
        valuesJoinType: EventFiltersValuesJoinType.SINGLE_VALUE,
    },
    {
        code: EventFilterCodes.drinkType,
        valuesJoinType: EventFiltersValuesJoinType.OR,
        title: 'Что в бокалах',
    },
    {
        code: EventFilterCodes.winery,
        valuesJoinType: EventFiltersValuesJoinType.OR,
        title: 'Винотека',
        isSearchable: true,
    },
    {
        code: EventFilterCodes.format,
        valuesJoinType: EventFiltersValuesJoinType.OR,
        title: 'Формат',
    },
    {
        code: EventFilterCodes.price,
        valuesJoinType: EventFiltersValuesJoinType.SINGLE_VALUE,
        title: 'Стоимость',
    },
    {
        code: EventFilterCodes.hall,
        valuesJoinType: EventFiltersValuesJoinType.SINGLE_VALUE,
    },
];

export const SELECT_WINE_SHOP_DEFAULT_TITLE = 'Выберите удобную винотеку';

export const FAQ_LIST: IFaqItem[] = [
    {
        description:
            'Кависты наших винотек — это профессионалы, которые проходили обучение у ведущих экспертов Simple Group. Погрузят в тему, объяснят нюансы, ответят на вопросы.',
        title: 'Кто проводит мероприятия?',
    },
    {
        description:
            'В формате исследования стиля вина, региона или другой заявленной темы. Все происходит в дегустационных залах или в общем зале винотеки за отдельным столом: вы пробуете 5-6 разных вин или другого алкоголя, а кавист рассказывает про каждую позицию.',
        title: 'Как проходит мероприятие?',
    },
    {
        description:
            'Все зависит от темы. У нас есть дегустации, где кависты рассказывают самые азы, а есть развлекательные форматы, которые объединяют как новичков, так и опытных дегустаторов.',
        title: 'На какой уровень рассчитаны мероприятия?',
    },
    {
        description: 'Обычно это 7-10 человек.',
        title: 'Сколько человек участвуют в мероприятиях с дегустацией?',
    },
    {
        description:
            'В среднем дегустация идет 1,5—2 часа. Опаздывать, конечно, можно, но лучше быть вовремя — так вы не пропустите первый сет и начало рассказа кависта. Уйти пораньше тоже можно.',
        title: 'Сколько длится мероприятие? Могу ли я опоздать или раньше уйти?',
    },
    {
        description: 'Вы можете сдать билет не позднее чем за 24 часа до начала дегустации.',
        title: 'Могу я поменять или вернуть билет?',
    },
    {
        description: 'Конечно. Все дегустации сопровождаются сыром, оливками и хлебными палочками гриссини.',
        title: 'Будут ли закуски?',
    },
    {
        description:
            'Если вы были на дегустации, которая сопровождалась не только рассказом кависта, но и презентацией, мы отправим ее по запросу.',
        title: 'После мероприятия я получу какие-то материалы?',
    },
    {
        description:
            'Да! После мероприятия (кроме формата «Салон вин») у вас будет скидка 20% на ассортимент винотеки, за исключением товаров с фиксированной ценой, упаковки, сувениров и Simple Collection.',
        title: 'Если мне понравится что-то на мероприятии, я смогу это купить?',
    },
];
